import React from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {Button, Typography} from "@deere/fuel-react";
import Stack from "@mui/material/Stack";

const ExternalWrapper = React.lazy(() => import('wrapper/ExternalWrapper'));

export const SupplierView = ({name}) => {
    const { supplierNum } = useParams();
    const history = useHistory();

    const onCancel = () => {
        history.push("/supplier-mnt");
    }

    return (
        <div>
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} mb={4}>
                <div>
                <Typography variant="h1" component="h1" display="inline">
                    {name}
                </Typography>
                {supplierNum && (
                    <Typography variant="h1" component="h1" display="inline">
                        {`- ${supplierNum}`}
                    </Typography>
                )}
                </div>
                <Button variant="secondary" onClick={() => onCancel()}>
                    Cancel
                </Button>
            </Stack>
            <React.Suspense fallback={"Loading..."}>
                <ExternalWrapper componentToShow={"supplier_maint_view"} componentProps={{ supplierNumber: supplierNum }} />
            </React.Suspense>
        </div>
    );
}
